import { useState, useEffect, useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "antd";
import { deleteBillHeader, getOneBillHeader, getBillFormData } from "../../redux/actions/bill.action";
import CrudButtons from "./components/CrudButtons";
import BillForm from "./components/Form/BillForm";
import PageHeader from "../../components/PageHeader/PageHeader";
import { ReadCookie } from "../../utils/readCookie";
import notification from "../../utils/notification";
import "../../screens/Product/product.css";
import "../Style/style.css";
import { TabTitle } from "../../utils/GeneralFunction";
import { getTransationLock } from "../../redux/actions/transactionLock.action";
import moment from "moment";

export default function Bill({ token, userRights }) {
	TabTitle("Bill")
	const dispatch = useDispatch();
	const companyId = ReadCookie("defaultCompany");
	const { log, bill } = useSelector((state) => state);
	const history = useHistory();
	const { id } = useParams();
	const [minimize, setMinimize] = useState(false);
	const [formState, setFormState] = useState("view");
	const [flag, setFlag] = useState(false);
	const [submit, setSubmit] = useState(false);
	const queryParams = new URLSearchParams(window.location.search);
	const mode = queryParams.get("mode");
	const [loading, setLoading] = useState(false);
	const [disable, setDisable] = useState(false);
	const [transactionLock, setTransactionLock] = useState(false)
	const menuId = userRights.col_menu_id

	const filterReset = () => {
		setFormState("view");
	};

	const handleDelete = () => {
		setLoading(true);
		dispatch(deleteBillHeader(token, id)).then((res) => {
			if (res.type === "DELETE_BILL_HEADER_SUCCESS") {

				setLoading(false);
				notification("success", "Bill Deleted", res.payload);
				setFlag(true);
				history.push("/bill/list");
			}
		});
	};

	const formSave = () => {
		setSubmit(true);
		setDisable(true)
	};

	useEffect(() => {
		if (mode === "add") {
			setFormState("add");
		}
		dispatch(getBillFormData(token));
	}, []);

	useEffect(() => {
		if (id) {
			setFormState("formView");
			dispatch(getOneBillHeader(token, id)).then((res) => {

				if (res?.type === "GET_ONE_BILL_HEADER_SUCCESS") {
					if (res?.payload?.data[0]?.bill_date) {
						let transaction_date = moment(res?.payload.data[0]?.bill_date).format("YYYY-MM-DD");
						dispatch(getTransationLock(token, transaction_date)).then((r) => {

							if (r.payload.data.length > 0) {
								setTransactionLock(true);
							}
						});
					}
				}
			});
		}
	}, [id]);

	return (
		<>
			<div className="styleContainer">
				<div className="styleBody h-100">
					<PageHeader title={"Bill"} minimize={setMinimize} check={minimize} />
					<div className="bodyStyle">
						<div className="crudDiv">
							<CrudButtons
								id={id}
								name={"saleOrder"}
								reset={filterReset}
								userRights={userRights}
								formType={formState}
								save={formSave}
								formState={setFormState}
								onDelete={handleDelete}
								saleOrderID={id}
								formData={bill?.payload?.data}
								disable={disable}
								transactionLock={transactionLock}
							/>
							<div className="mainProductContainer">
								<BillForm
									loading={loading}
									companyId={companyId}
									submit={setSubmit}
									val={submit}
									formData={formState === "formView" || formState === "edit" ? bill?.payload?.data[0] : null}
									formState={formState}
									changeState={setFormState}
									token={token}
									checkFlag={flag}
									setFlag={setFlag}
									logs={log}
									saleOrderID={id}
									setDisable={setDisable}
									transactionLock={transactionLock}
									menuId={menuId}
								/>
							</div>
						</div>
					</div>
				</div>
				{minimize && (
					<div className="styleFooter">
						{" "}
						<Button className="minimize-button-style" onClick={() => setMinimize(false)}>
							{" "}
							Bill{" "}
						</Button>{" "}
					</div>
				)}
			</div>
		</>
	);
}
